import BS_1377_9_Clause_2_2 from './Bs/Config';

export default {
  ...BS_1377_9_Clause_2_2,
};
